var time = require('./time')

function rafFallback(fn) {
	return setTimeout(
		function() {
			fn(time())
		},
		16
	)
}

var raf = window.requestAnimationFrame
  || window.webkitRequestAnimationFrame
  || window.mozRequestAnimationFrame
  || window.oRequestAnimationFrame
  || window.msRequestAnimationFrame
  || rafFallback

var cancelFunc = window.cancelAnimationFrame
  || window.webkitCancelAnimationFrame
  || window.mozCancelAnimationFrame
  || window.oCancelAnimationFrame
  || window.msCancelAnimationFrame
  || window.clearTimeout

raf.cancel = function cancel(id) {
	cancelFunc.call(window, id)
}

export default raf
